module.exports = __webpack_public_path__ + "img/velans-sub-features-1.8c9a096.jpg";